<template>
  <section>
    <el-row style="background:#fff">
      <el-col :sm="12" :xs="24" :span="12">
        <el-row :gutter="10"></el-row>
      </el-col>
    </el-row>
    <!-- 图表 -->
    <el-row style="padding:15px;background:#fff">
      <el-button icon="el-icon-arrow-left" circle @click="$router.push({ name:'基础数据' })"></el-button>
      <!-- params:{edate:pdata.edate,sdate:pdata.sdate,app_id:pdata.app_id,name:pname} -->
      <el-radio-group
        v-model="getWhich"
        @change="changeGet"
        class="rgroup "
        style="margin-left:60px"
      >
        <el-radio-button label="访问分析" class="radio xs24"></el-radio-button>
        <el-radio-button label="来源分析" class="radio xs24"></el-radio-button>
        <el-radio-button label="用户画像" class="radio xs24"></el-radio-button>
      </el-radio-group>

      <div style="float:right; text-align: right;">
        <el-button class="xs24" type="primary" plain @click="changeDate(1)">昨天</el-button>
        <el-button  class="xs24" type="primary" plain @click="changeDate(7)">最近7天</el-button>
        <el-date-picker
        	 class="xs24"
          v-model="dateVal"
          type="daterange"
          range-separator="至"
          :start-placeholder="pdata.sdate"
          :end-placeholder="pdata.edate"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
    </el-row>
    <el-row  v-if="getWhich=='访问分析'">
      <div style="width:100%;margin:20px auto 0;padding:0 20px;box-sizing:border-box">
        <el-select class="xs24" v-model="pdata.visit" placeholder="请选择" @change="select">
          <el-option v-for="(vv,k) in config" :key="k" :value="k" :label="vv"></el-option>
        </el-select>
      </div>
    </el-row>
    <el-row style="min-width:1200px" v-if="getWhich=='访问分析'">
      <div id="chart" style="width:100%; height:500px;"></div>
    </el-row>
    <el-row style="min-width:1200px" class="lyfx" v-if="getWhich=='来源分析'">
      <div id="chart1" style="margin:20px;width:100%;height:400px;"></div>
      <div id="chart2" style="margin:20px;width:100%;height:400px;"></div>>
      <div id="chart3" style="margin:20px;width:100%;height:400px;"></div>
      <div id="chart4" style="margin:20px;width:100%;height:400px;"></div>
    </el-row>
    <el-row style="min-width:1200px" class="lyfx" v-if="getWhich=='用户画像'">
      <div id="c1" style="margin:20px;width:100%;height:400px;"></div>
      <div id="c2" style="margin:20px;width:100%;height:400px;"></div>>
      <div id="c3" style="margin:20px;width:100%;height:400px;"></div>
      <div id="c4" style="margin:20px;width:100%;height:400px;"></div>
    </el-row>
  </section>
</template>

<script>
import { getBasiVisit, getBasiFrom, getBasiUser } from "../../api/api";
import echarts from "echarts";

export default {
  data() {
    return {
      getWhich: "访问分析",
      chartColumn: null,
      pdata: {
        app_id: "",
        // sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        // edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        sdate: "",
        edate: ""
      },
      plist: [],
      maxPage: 1,
      config: { visit_uv: "访问人数" },
      editDialog: false,
      group: {},

      dateVal: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 }, //所有数据
      option: {
        tooltip: { trigger: "axis"},
        legend: { data: ["打开次数"] },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: { type: "category",  data: [] },
        yAxis: { type: "value" },
        series: [{ name: "打开次数", type: "line", smooth: true, data: [] }],
        color: [
          "#61c0a0",
          "#ee4f54",
          "#8ec1b0",
          "#a6e8ba",
          "#ceead4",
          "#f2e247",
          "#f6e98b",
          "#f77b31",
          "#fc9656",
          "#ec151a",
          "#ee4f54",
          "#ee2159",
          "#fbaaa6"
        ]
      },
      option1: {
        // title: { text: "整体来源分布" },
        tooltip: { trigger: "axis"},
        toolbox: {
          show: true
        },
        xAxis: { type: "category",  data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "bar", smooth: true, data: [] }],
        color: ["#61c0a0"]
      },
      option2: {
        // title: { text: "场景访问人数" },
        tooltip: { trigger: "axis"},
        toolbox: {
          show: true
        },
        xAxis: { type: "category",  data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "line", smooth: true, data: [] }],
        color: ["#ec151a"]
      },
      option3: {
        // title: { text: "平均停留时长" },
        tooltip: { trigger: "axis"},
        toolbox: {
          show: true
        },
        xAxis: { type: "category",  data: [] },
        yAxis: { type: "value" },
        series: [{ name: "打开次数", type: "line", smooth: true, data: [] }],
        color: ["#ec151a"]
      },
      option4: {
        // title: { text: "平均访问深度" },
        tooltip: { trigger: "axis"},
        toolbox: {
          show: true
        },
        xAxis: { type: "category",  data: [] },
        yAxis: { type: "value" },
        series: [{ name: "人数", type: "line", smooth: true, data: [] }],
        color: ["#f2e247"]
      },
      //用户画像
      o1: {
        tooltip: { trigger: "axis"},
        toolbox: { show: true },
        xAxis: { type: "category",  data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "line", smooth: true, data: [] }],
        color: ["#61c0a0"]
      },
      o2: {
        tooltip: { trigger: "axis"},
        toolbox: { show: true },

        xAxis: { type: "category",  data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "bar", smooth: true, data: [] }],
        color: ["#61c0a0","#ee4f54","#8ec1b0","#a6e8ba","#ceead4","#f2e247","#f6e98b","#f77b31","#fc9656","#ec151a","#ee4f54","#ee2159","#fbaaa6"]
      },
      o3: {
        tooltip: { trigger: "axis"},
        toolbox: { show: true },
        xAxis: { type: "category",  data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "bar", smooth: true, data: [] }],
        color: ["#ee4f54","#8ec1b0","#a6e8ba","#ceead4","#61c0a0","#ee4f54","#8ec1b0","#a6e8ba","#ceead4","#f2e247","#f6e98b","#f77b31","#fc9656","#ec151a","#ee4f54","#ee2159","#fbaaa6"]
      },
      o4: {
        tooltip: { trigger: "axis"},
        toolbox: { show: true },
        xAxis: { type: "category",  data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "bar", smooth: true, data: [] }],
        color: ["#f77b31","#fc9656","#ec151a","#ee4f54","#61c0a0","#ee4f54","#8ec1b0","#a6e8ba","#ceead4","#f2e247","#f6e98b","#f77b31","#fc9656","#ec151a","#ee4f54","#ee2159","#fbaaa6"]
      }
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    }
  },
  methods: {
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      if (this.getWhich == "访问分析") {
        getBasiVisit(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.cdata = res.data;
            this.option.xAxis.data = JSON.parse(res.data.chart.dates);
            this.option.series[0].data = JSON.parse(res.data.chart.data);
            this.pname = res.data.app_info.name;
            this.config = res.data.visits;
            this.drawColumnChart();
          }
        });
      } else if (this.getWhich == "来源分析") {
        if (!this.pdata.source) {
          p += "source=22";
        }
        getBasiFrom(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.cdata = res.data;
            this.option1.xAxis.data = JSON.parse(res.data.chart_y1);

            this.option1.series[0].data = JSON.parse(res.data.chart_x1);
            this.sources = JSON.parse(res.data.sources);
            this.option2.xAxis.data = JSON.parse(res.data.chart_x2);
            this.option2.series[0].data = JSON.parse(res.data.chart_y2);
            this.option3.xAxis.data = JSON.parse(res.data.chart_y3);
            this.option3.series[0].data = JSON.parse(res.data.chart_x3);
            this.option4.xAxis.data = JSON.parse(res.data.chart_y4);
            this.option4.series[0].data = JSON.parse(res.data.chart_x4);

            this.pname = res.data.app_info.name;
            this.config = res.data.visits;
            this.drawColumnChart1();
          }
        });
      } else {
        getBasiUser(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.cdata = res.data;
            this.o1.xAxis.data = JSON.parse(res.data.chart_x1);
            this.o1.series[0].data = JSON.parse(res.data.chart_y1);
            this.o2.xAxis.data = JSON.parse(res.data.chart_y4);
            this.o2.series[0].data = JSON.parse(res.data.chart_x4);
            this.o3.xAxis.data = JSON.parse(res.data.chart_y5);
            this.o3.series[0].data = JSON.parse(res.data.chart_x5);
            this.o4.xAxis.data = JSON.parse(res.data.chart_y6);
            this.o4.series[0].data = JSON.parse(res.data.chart_x6);
            this.drawColumnChart2();
          }
        });
      }
    },
    drawColumnChart() {
      this.chartColumn = echarts.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    drawColumnChart1() {
      this.chartColumn1 = echarts.init(document.getElementById("chart1"));
      this.chartColumn1.setOption(this.option1);

      this.chartColumn2 = echarts.init(document.getElementById("chart2"));
      this.chartColumn2.setOption(this.option2);
      this.chartColumn3 = echarts.init(document.getElementById("chart3"));
      this.chartColumn3.setOption(this.option3);
      this.chartColumn4 = echarts.init(document.getElementById("chart4"));
      this.chartColumn4.setOption(this.option4);
    },
    drawColumnChart2() {
      this.chartColumn5 = echarts.init(document.getElementById("c1"));
      this.chartColumn5.setOption(this.o1);
      this.chartColumn6 = echarts.init(document.getElementById("c2"));
      this.chartColumn6.setOption(this.o2);
      this.chartColumn7 = echarts.init(document.getElementById("c3"));
      this.chartColumn7.setOption(this.o3);
      this.chartColumn8 = echarts.init(document.getElementById("c4"));
      this.chartColumn8.setOption(this.o4);
    },

    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = "";
      this.pdata.sdate = new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
        .toISOString()
        .slice(0, 10);
      this.pdata.edate = new Date(new Date().getTime() - 3600 * 1000 * 24)
        .toISOString()
        .slice(0, 10);
      this.getList();
    },
    changeGet() {
      this.getList();
    },
    select(ss) {
      this.option.legend.data = [this.config[ss]];
      this.option.series[0].name = this.config[ss];
      this.getList();
    }
  },

  mounted() {
    // this.getConfig();
    this.pdata = this.$route.params;
    this.pdata.type = 1;
    var p =
      "app_id=" +
      this.pdata.app_id +
      "&type=1&visit=visit_uv&sdate=" +
      this.$route.params.sdate +
      "&edate=" +
      this.$route.params.edate;
    getBasiVisit(p, this.$cookie.getCookie("login")).then(res => {
      if (res.code == 200) {
        this.cdata = res.data;
        this.option.xAxis.data = JSON.parse(res.data.chart.dates);
        this.option.series[0].data = JSON.parse(res.data.chart.data);
        this.pname = res.data.app_info.name;
        this.config = res.data.visits;
        this.pdata.visit = "visit_uv";
        this.option.legend.data = [this.config.visit_uv];
        this.option.series[0].name = this.config.visit_uv;
        this.drawColumnChart();
      }
    });
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
.rgroup .radio .el-radio-button__inner {
  padding: 12px 50px;
}
</style>
<style scoped>
.total {
  font-size: 20px;
  height: 50px;
  line-height: 50px;
  margin: 20px auto;
}
.lyfx {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 100%;
  padding: 0 50px;
}
</style>





// WEBPACK FOOTER //
// basicDetail.vue?391c9426